import { Injectable, inject } from '@angular/core';
import { StorageService } from 'src/app/storage.service';
import { ServerChunk } from './chunk/chunk.dto';
import { ContentChunkRef, ServerContent } from './content.dto';

@Injectable({
  providedIn: 'root',
})
export class ContentUtilsService {
  private storageService = inject(StorageService);

  /**
   * Composes a content object by replacing its chunk references with full chunk data
   * fetched from local storage.
   *
   * @param content - The ServerContent object with an array of chunk references.
   * @returns A Promise that resolves to the ServerContent object with its 'contents'
   * array populated with full ServerChunk objects.
   */
  public async composeContentWithChunks(content: ServerContent): Promise<any> {
    if (!content || !content.contents) {
      return content;
    }
    const chunkIds = content.contents.map((ref: any) => ref.chunk || ref._id);
    const chunksFromStorage: ServerChunk[] = await this.storageService.find('chunks', chunkIds);
    const chunkMap = new Map<string, ServerChunk>(chunksFromStorage.map((chunk) => [chunk._id, chunk]));

    const composedContents = content.contents
      .map((ref: any) => {
        const id = ref.chunk || ref._id;
        const fullChunk = chunkMap.get(id);
        if (!fullChunk) {
          return null;
        }
        return {
          ...fullChunk,
          style: ref.style,
        };
      })
      .filter((c) => c !== null);

    return {
      ...content,
      contents: composedContents,
    };
  }
}
